import lscache from "lscache";

const PHONE_VERIFICATION_TIMER_START_LS_KEY = "phoneVerificationTimerStart";

export const clearPhoneVerificationTimerLS = () => {
    lscache.remove(PHONE_VERIFICATION_TIMER_START_LS_KEY);
};
import lscache from "lscache";

const PHONE_VERIFICATION_TIMER_START_LS_KEY = "phoneVerificationTimerStart";

export const clearPhoneVerificationTimerLS = () => {
    lscache.remove(PHONE_VERIFICATION_TIMER_START_LS_KEY);
};
